/**
 * A stamp the server wrote — created_at, paid_at, updated_at, published_at.
 *
 * Those are UTC written without a zone ("2026-09-21 07:09:42" is 12:39 in
 * India). Read as local time they come out five and a half hours early, so
 * a stamp with no zone of its own is read as UTC. A bare date stays a date.
 * (A live class's start time is the other kind — India time as typed — and
 * is shown as typed in the batch form, so it never comes through here.)
 */
const ZONED = /(Z|[+-]\d\d:?\d\d)$/i;

export function parseStamp(v?: string | null): Date | null {
  if (!v) return null;
  const t = String(v).trim().replace(' ', 'T');
  const d = new Date(!t.includes('T') || ZONED.test(t) ? t : `${t}Z`);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "21 Sep 26" — the date column in the console's lists. */
export const stampDay = (v?: string | null) => {
  const d = parseStamp(v);
  return d ? d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: '2-digit' }) : '—';
};
